function initialize() {
  // var date = new Date();
  // var body = document.getElementsByTagName('body')[0];
  console.log("Currently, no accessiblity features are enabled");
}

initialize();
